/* Layout normaliser for Webflow rich-text HTML. Rules + measurements:
 * docs/science-study-typography.md#rich-text-sanitizer
 *
 * NOT a security sanitiser — script/handler/javascript: stripping happens at the
 * data boundary in cms.ts (sanitize-html). Stays dependency-free and pure: the
 * client-side RichText component imports it, and so does the import pipeline.
 */

const PXPX = /max-width:\s*(\d+(?:\.\d+)?)pxpx\b/gi;
const PX_VALUE = /max-width:\s*(\d+(?:\.\d+)?)px\b/gi;
const EMPTY_P = /<p[^>]*>(?:\s|&nbsp;|&#x200d;|‍|‍)*<\/p>/gi;

// Widest body column is 980px; 1024 clears it without shrinking figures a
// designer deliberately made smaller.
const PIXEL_CAP = 1024;

export function sanitizeRichTextHtml(html: string): string {
  if (!html) return '';

  let out = html;

  out = out.replace(PXPX, (_, n) => `max-width:${n}px`);

  out = out.replace(PX_VALUE, (m, n) => {
    const px = parseFloat(n);
    if (Number.isFinite(px) && px > PIXEL_CAP) {
      return `max-width:${PIXEL_CAP}px`;
    }
    return m;
  });

  out = out.replace(EMPTY_P, '');

  return out;
}
